import { render, staticRenderFns } from "./Newkey.vue?vue&type=template&id=2b32075c"
import script from "./Newkey.vue?vue&type=script&lang=js"
export * from "./Newkey.vue?vue&type=script&lang=js"
import style0 from "./Newkey.vue?vue&type=style&index=0&id=2b32075c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports